import { InspectionModel } from 'shared/domain/inspection/inspectionModel';
import { DomainMessagesTypes } from 'shared/domain/messages/message';
import { readInspectionModels } from 'serviceWorker/services/inspections/inspectionReads';
import * as inspectionsService from '../db/inspections/inspectionsService';
import { inspectionContract } from 'shared/domain/inspection/inspectionContract';
import {
  makeErrorPublisher,
  makeEventPublisher,
  makeLoadedEventPublisher,
  readCollectionPayload,
} from 'serviceWorker/broadcasts/publishers';

export const broadcastAllInspections = makeLoadedEventPublisher(
  inspectionContract,
  DomainMessagesTypes.allInspections,
  () => readCollectionPayload(inspectionsService, readInspectionModels)
);

const broadcastInspectionErrorRaw = makeErrorPublisher(inspectionContract);

function broadcastInspectionError(
  error: unknown,
  uniqueId?: string,
  messageId?: string | null
): void {
  broadcastInspectionErrorRaw(DomainMessagesTypes.failUploadedEntity, error, {
    uniqueId,
    messageId: messageId ?? undefined,
  });
}

export const broadcastUploadedInspection = makeEventPublisher(inspectionContract, DomainMessagesTypes.uploadedEntity);

export const broadcastUpdatedInspection = makeEventPublisher(inspectionContract, DomainMessagesTypes.updatedEntity);

export const broadcastDeletedInspection = makeEventPublisher(inspectionContract, DomainMessagesTypes.deletedEntity);

export const broadcastRestoredInspection = makeEventPublisher(inspectionContract, DomainMessagesTypes.updatedEntity);

export const broadcastUploadedInspectionError = (
  error: any,
  uniqueId?: string,
  messageId?: string | null
): void => {
  broadcastInspectionError(error, uniqueId, messageId);
};

export const broadcastUpdatedProtocolItem = makeEventPublisher(inspectionContract, DomainMessagesTypes.updatedEntity);

export const broadcastUpdatedProtocolItemError = (
  error: any,
  uniqueId?: string,
  messageId?: string | null
): void => {
  broadcastInspectionError(error, uniqueId, messageId);
};

export const broadcastUpdatedProtocolSection = makeEventPublisher(inspectionContract, DomainMessagesTypes.updatedEntity);

export const broadcastUpdatedProtocolSectionError = (
  error: any,
  uniqueId?: string,
  messageId?: string | null
): void => {
  broadcastInspectionError(error, uniqueId, messageId);
};
